import React from "react";
import PropTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";

export default function FooterSimple(props) {
  return (
    <footer className="text-light bg-primary py-5" aria-label="footer">
      <Container>
        <Row>
          {props.name && (
            <Col xs={12} md={4}>
              <h1 className="h4 mb-3">
                <a
                  href="/"
                  className="link link-bold font-weight-bold link-light "
                >
                  {props.name}
                </a>
              </h1>
            </Col>
          )}
          {props.text && (
            <Col className="small" md={12}>
              {props.text}
            </Col>
          )}
          {props.link && (
            <Col className="small" md={12}>
              <a 
                href="https://uustatus.no/nb/erklaringer/publisert/10b23baa-4c9f-4ce6-8e80-9bf109dc6604" 
                target="_self"
                className="link "
              >
                {props.link}
              </a>
            </Col>
          )}
        </Row>
      </Container>
    </footer>
  );
}

FooterSimple.propTypes = {
  name: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string
};

FooterSimple.defaultProps = {
  name: "Prosjektnavn",
  text:
    "[Navnet] copyright 2020. Utvikla av fellesadministrasjonen på oppdrag av [Navn].",
  link: "Tilgjengelighetserklæring (uustatus.no)",
};
